import BlogSearchCard from '@components/blog-posts/blog-search-card';
import ShowMore from '@components/showmore-button';
import SubHeading from '@components/sub-heading';
import { Pagination } from '@constants/common';
import { fetchBlogList } from '@lib/API/blogAPI';
import useTranslation from 'next-translate/useTranslation';
import React, { useEffect, useState } from 'react';
import { BlogCardProps } from 'src/types';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

type API_STATE = 'IDLE' | 'PENDING' | 'SUCESS' | 'FAILED';

function RecentPosts() {
  const { lang } = useTranslation();

  const language = lang.toUpperCase();

  const [searchedBlogList, setSearchedBlogList] = useState<BlogCardProps[]>([]);
  const [totalBlogCount, setTotalBlogCount] = useState<number>(0);
  const [status, setStatus] = useState<API_STATE>('IDLE');

  async function defaultSearchBlogs({ start }: { start: number }) {
    try {
      setStatus('PENDING');

      const { blogList, totalBlogCount } = await fetchBlogList({
        start,
        limit: Pagination.SEARCHED_BLOGS_PER_PAGE,
        language: language || 'EN',
      });
      setSearchedBlogList(searchedBlogList => [
        ...searchedBlogList,
        ...blogList,
      ]);
      setTotalBlogCount(totalBlogCount);
      setStatus('SUCESS');
    } catch (error: any) {
      console.log(error.message);
      setStatus('FAILED');
    }
  }

  useEffect(() => {
    setSearchedBlogList([]);

    defaultSearchBlogs({ start: 0 });

    setTotalBlogCount(0);
  }, []);

  return (
    <div
      className={ivclass(
        'iv-container iv-mx-auto',
        'iv-pt-[91px] lg:iv-pt-[91px] md:iv-pt-[52px] sm:iv-pt-[44px]',
        'iv-pb-100 md:iv-pb-50 sm:iv-pb-30',
        'lg:iv-pl-[43px] md:iv-pl-[25px]',
      )}
    >
      <div className={ivclass('iv-grid iv-grid-cols-12 iv-col-span-12 ')}>
        <div className={ivclass('iv-col-span-12')}>
          <SubHeading title="Recent Articles" />
        </div>
      </div>

      <div className={ivclass('iv-grid iv-grid-cols-12')}>
        {searchedBlogList.length !== 0 && (
          <div
            className={ivclass(
              'iv-col-start-2 iv-col-span-10 md:iv-col-span-12 sm:iv-col-span-12 ',
              'md:iv-col-start-1',
              'iv-px-20 lg:iv-px-[0] md:iv-px-[65px]',
            )}
          >
            <div className={ivclass('iv-mb-100')}>
              <div
                className={ivclass(
                  'iv-grid iv-grid-cols-12',
                  'iv-gap-x-40 iv-gap-y-[95px] ',
                  'lg:iv-gap-y-[73px] ',
                  'md:iv-gap-x-[0] md:iv-gap-y-[73px] ',
                  'sm:iv-gap-x-[0] sm:iv-gap-y-[0] ',
                )}
              >
                {searchedBlogList.length > 0 &&
                  searchedBlogList.map(post => (
                    <div
                      key={post.id}
                      className={ivclass(
                        'iv-col-span-6 md:iv-col-span-12 sm:iv-col-span-12',
                        'sm:iv-mb-[40px]',
                      )}
                    >
                      <BlogSearchCard
                        title={post.title}
                        slug={post.slug}
                        image={post.featureImage}
                      />
                    </div>
                  ))}
              </div>
              <div
                className={ivclass(
                  'xl:iv-mt-100 lg:iv-mt-100 md:iv-mt-80 sm:iv-mt-50',
                )}
              >
                <ShowMore
                  isPaginationEnded={searchedBlogList.length == totalBlogCount}
                  showMoreAction={() =>
                    defaultSearchBlogs({
                      start: searchedBlogList.length,
                    })
                  }
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default RecentPosts;
